(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snow-white-inner-circle"] && !Shopify.designMode) return;
  try {
    
  class SnowWhiteStory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return
      this.dataset.ready = 'true'
      const query = new URLSearchParams(window.location.search)
      const memberSignals = [query.get('ic_member'), query.get('utm_content')]
        .filter(Boolean)
        .map((value) => value.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_'))
      const memberEmailView = memberSignals.some((value) => ['1', 'true', 'ic_member', 'active_ic_member', 'active_inner_circle_member'].includes(value))
      if (memberEmailView) this.classList.add('is-member-view')
      this.memberView = this.classList.contains('is-member-view')
      this.charmStorageKey = `snow-white-ruby-apples:${window.location.pathname}`
      this.foundCharmIds = new Set()
      try {
        const storedCharms = JSON.parse(window.sessionStorage.getItem(this.charmStorageKey) || '[]')
        storedCharms.forEach((id) => this.foundCharmIds.add(String(id)))
      } catch (error) {
        this.foundCharmIds.clear()
      }
      this.charmsFound = this.foundCharmIds.size
      this.mirrorIndex = 0
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      this.progressBar = this.querySelector('[data-story-progress]')
      this.motionButton = this.querySelector('[data-motion-toggle]')
      this.motionLabel = this.querySelector('[data-motion-label]')
      this.musicButton = this.querySelector('[data-music-toggle]')
      this.musicLabel = this.querySelector('[data-music-label]')
      this.membershipCard = this.querySelector('[data-membership-card]')
      this.membershipBack = this.querySelector('[data-membership-back]')
      this.purchaseButton = this.querySelector('[data-purchase-reveal]')
      this.buyBoxSlot = this.querySelector('[data-buy-box-slot]')
      this.liveRegion = this.querySelector('[data-story-live]')
      this.counts = Array.from(this.querySelectorAll('[data-charm-count]'))
      this.questTally = this.querySelector('[data-quest-tally]')
      this.mirrorResult = this.querySelector('[data-mirror-result]')
      this.mirrorButton = this.querySelector('[data-mirror]')
      this.mirrorAnswer = this.querySelector('[data-mirror-answer]')
      this.mirrorMessages = Array.from(this.querySelectorAll('[data-mirror-message]')).map((node) => node.textContent.trim())
      this.completeMessage = this.querySelector('[data-mirror-complete]')?.textContent.trim() || ''
      this.reveals = Array.from(this.querySelectorAll('.sw-reveal'))
      this.chapters = Array.from(this.querySelectorAll('[data-chapter]'))
      this.productCards = Array.from(this.querySelectorAll('[data-product-card]'))
      this.logoutLink = this.querySelector('[data-member-logout]')
      this.onScroll = this.onScroll.bind(this)
      this.dockPurchaseBox = this.dockPurchaseBox.bind(this)
      this.motionButton?.addEventListener('click', () => this.toggleMotion())
      this.musicButton?.addEventListener('click', () => this.toggleMusic())
      if (!this.memberView) this.purchaseButton?.addEventListener('click', () => this.revealPurchase())
      this.mirrorButton?.addEventListener('click', () => this.askMirror())
      this.querySelectorAll('[data-charm]').forEach((button) => {
        if (this.foundCharmIds.has(button.dataset.charm)) button.disabled = true
        button.addEventListener('click', () => this.collectCharm(button))
      })
      this.productCards.forEach((card) => {
        card.dataset.slideIndex = '0'
        card.querySelector('[data-product-prev]')?.addEventListener('click', () => this.showProductSlide(card, Number(card.dataset.slideIndex) - 1))
        card.querySelector('[data-product-next]')?.addEventListener('click', () => this.showProductSlide(card, Number(card.dataset.slideIndex) + 1))
        card.querySelectorAll('[data-product-dot]').forEach((dot) => dot.addEventListener('click', () => this.showProductSlide(card, Number(dot.dataset.productDot))))
        this.showProductSlide(card, 0)
      })
      this.logoutLink?.addEventListener('click', (event) => this.logoutMember(event))
      this.syncCharmState()
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible')
        })
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' })
      this.reveals.forEach((item) => this.observer.observe(item))
      window.addEventListener('scroll', this.onScroll, { passive: true })
      if (!this.memberView) {
        if (document.readyState === 'complete') {
          window.setTimeout(this.dockPurchaseBox, 0)
        } else {
          window.addEventListener('load', this.dockPurchaseBox, { once: true })
        }
      }
      this.onScroll()
      if (query.get('show_join') === '1') {
        this.classList.add('is-returned-from-logout')
        window.setTimeout(() => this.membershipCard?.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'center' }), 120)
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect()
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('load', this.dockPurchaseBox)
      this.stopMusic()
    }

    toggleMotion() {
      const paused = this.dataset.motion === 'paused'
      this.dataset.motion = paused ? 'playing' : 'paused'
      this.motionButton?.setAttribute('aria-pressed', paused ? 'false' : 'true')
      if (this.motionLabel) this.motionLabel.textContent = paused ? this.dataset.pauseLabel : this.dataset.playLabel
    }

    async toggleMusic() {
      if (this.musicPlaying) {
        this.stopMusic()
        return
      }

      const AudioContext = window.AudioContext || window.webkitAudioContext
      if (!AudioContext) return
      this.audioContext = new AudioContext()
      await this.audioContext.resume()
      this.musicGain = this.audioContext.createGain()
      this.musicGain.gain.setValueAtTime(0.0001, this.audioContext.currentTime)
      this.musicGain.gain.exponentialRampToValueAtTime(0.24, this.audioContext.currentTime + 1.2)
      this.musicGain.connect(this.audioContext.destination)
      this.musicPlaying = true
      this.musicButton?.setAttribute('aria-pressed', 'true')
      if (this.musicLabel) this.musicLabel.textContent = this.dataset.pauseMusicLabel
      this.playMusicPhrase()
      this.musicTimer = window.setInterval(() => this.playMusicPhrase(), 9400)
    }

    stopMusic() {
      window.clearInterval(this.musicTimer)
      this.musicTimer = null
      this.musicPlaying = false
      this.musicButton?.setAttribute('aria-pressed', 'false')
      if (this.musicLabel) this.musicLabel.textContent = this.dataset.playMusicLabel
      if (!this.audioContext || !this.musicGain) return
      const context = this.audioContext
      const now = context.currentTime
      this.musicGain.gain.cancelScheduledValues(now)
      this.musicGain.gain.setValueAtTime(Math.max(0.0001, this.musicGain.gain.value), now)
      this.musicGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.55)
      window.setTimeout(() => context.close(), 650)
      this.audioContext = null
      this.musicGain = null
    }

    playMusicPhrase() {
      if (!this.audioContext || !this.musicGain) return
      const context = this.audioContext
      const start = context.currentTime + 0.08
      const notes = [523.25, 659.25, 783.99, 880, 783.99, 659.25, 587.33, 523.25]
      notes.forEach((frequency, index) => {
        const tone = context.createOscillator()
        const shimmer = context.createOscillator()
        const envelope = context.createGain()
        const shimmerEnvelope = context.createGain()
        const noteStart = start + (index * 0.82)
        tone.type = 'sine'
        tone.frequency.setValueAtTime(frequency, noteStart)
        shimmer.type = 'sine'
        shimmer.frequency.setValueAtTime(frequency * 2, noteStart)
        envelope.gain.setValueAtTime(0.0001, noteStart)
        envelope.gain.exponentialRampToValueAtTime(index % 2 ? 0.026 : 0.035, noteStart + 0.035)
        envelope.gain.exponentialRampToValueAtTime(0.0001, noteStart + 2.2)
        shimmerEnvelope.gain.setValueAtTime(0.0001, noteStart)
        shimmerEnvelope.gain.exponentialRampToValueAtTime(0.012, noteStart + 0.02)
        shimmerEnvelope.gain.exponentialRampToValueAtTime(0.0001, noteStart + 1.2)
        tone.connect(envelope)
        shimmer.connect(shimmerEnvelope)
        envelope.connect(this.musicGain)
        shimmerEnvelope.connect(this.musicGain)
        tone.start(noteStart)
        shimmer.start(noteStart)
        tone.stop(noteStart + 2.25)
        shimmer.stop(noteStart + 1.25)
      })
    }

    dockPurchaseBox() {
      if (this.memberView) return
      this.buyBox = document.querySelector('.shopify-section[id$="__snow_white_buy_box"]')
      if (!this.buyBox || !this.buyBoxSlot || window.Shopify?.designMode) return
      this.buyBoxSlot.append(this.buyBox)
    }

    revealPurchase() {
      if (this.memberView) return
      this.dockPurchaseBox()
      this.membershipCard?.classList.add('is-purchase-open')
      this.membershipBack?.setAttribute('aria-hidden', 'false')
      this.purchaseButton?.setAttribute('aria-expanded', 'true')
      this.buyBox?.classList.add('sw-buy-box--revealed')
      if (this.liveRegion) this.liveRegion.textContent = 'The membership choices are now open.'
      window.setTimeout(() => {
        const target = this.buyBoxSlot?.contains(this.buyBox) ? this.membershipCard : this.buyBox
        target?.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'start' })
        this.buyBox?.querySelector('select, input:not([type="hidden"]), button')?.focus({ preventScroll: true })
      }, this.prefersReducedMotion ? 0 : 720)
    }

    showProductSlide(card, index) {
      if (!card) return
      const slides = Array.from(card.querySelectorAll('[data-product-slide]'))
      const dots = Array.from(card.querySelectorAll('[data-product-dot]'))
      const caption = card.querySelector('[data-product-caption]')
      if (!slides.length) return
      const total = slides.length
      const activeIndex = ((index % total) + total) % total
      card.dataset.slideIndex = String(activeIndex)
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex
        slide.classList.toggle('is-active', active)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true')
      })
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
      const activeSlide = slides[activeIndex]
      if (caption && activeSlide?.dataset.caption) caption.textContent = activeSlide.dataset.caption
    }

    async logoutMember(event) {
      event.preventDefault()
      if (!this.logoutLink) return
      this.membershipCard?.classList.add('is-logging-out')
      if (this.liveRegion) this.liveRegion.textContent = 'Logging out and opening the gift purchase option.'
      try {
        await fetch(this.logoutLink.href, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          redirect: 'follow'
        })
      } catch (error) {
        // The top-level navigation below remains the reliable fallback.
      }
      window.location.assign(`${window.location.pathname}?show_join=1#snow-white-membership`)
    }

    syncCharmState() {
      this.charmsFound = this.foundCharmIds.size
      this.counts.forEach((count) => { count.textContent = String(this.charmsFound) })
      this.classList.toggle('has-charms', this.charmsFound > 0)
      this.questTally?.setAttribute('aria-hidden', this.charmsFound > 0 ? 'false' : 'true')
      if (this.charmsFound === 3) {
        this.classList.add('is-complete')
      }
    }

    collectCharm(button) {
      if (button.disabled) return
      button.disabled = true
      this.foundCharmIds.add(button.dataset.charm)
      try {
        window.sessionStorage.setItem(this.charmStorageKey, JSON.stringify(Array.from(this.foundCharmIds)))
      } catch (error) {
        // The quest still works when browser storage is unavailable.
      }
      this.syncCharmState()
      const message = this.charmsFound === 3
        ? this.dataset.completeLabel
        : `${this.charmsFound} ${this.dataset.foundLabel}`
      if (this.liveRegion) this.liveRegion.textContent = message
    }

    askMirror() {
      if (!this.mirrorAnswer) return
      if (!this.mirrorMessages.length) return
      const nextMessage = this.mirrorMessages[this.mirrorIndex % this.mirrorMessages.length]
      this.mirrorAnswer.classList.add('is-changing')
      this.mirrorButton?.classList.add('has-answer')
      window.setTimeout(() => {
        this.mirrorAnswer.textContent = nextMessage
        this.mirrorAnswer.classList.remove('is-changing')
        this.mirrorIndex += 1
      }, this.prefersReducedMotion ? 0 : 180)
    }

    onScroll() {
      if (this.scrollTicking) return
      this.scrollTicking = true
      window.requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect()
        const total = Math.max(1, rect.height - window.innerHeight)
        const progress = Math.min(1, Math.max(0, -rect.top / total))
        this.style.setProperty('--sw-progress', `${progress * 100}%`)
        if (!this.prefersReducedMotion && this.dataset.motion !== 'paused') {
          const heroProgress = Math.min(1, Math.max(0, -rect.top / Math.max(1, window.innerHeight)))
          this.style.setProperty('--sw-scroll', String(heroProgress))
          this.style.setProperty('--sw-hero-scale', String(1.07 - (heroProgress * 0.04)))
        }
        this.scrollTicking = false
      })
    }
  }

  if (!customElements.get('snow-white-story')) customElements.define('snow-white-story', SnowWhiteStory)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snow-white-membership-proof"] && !Shopify.designMode) return;
  try {
    
  class SnowWhiteProof extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return
      this.dataset.ready = 'true'
      const query = new URLSearchParams(window.location.search)
      const memberSignals = [query.get('ic_member'), query.get('utm_content')]
        .filter(Boolean)
        .map((value) => value.toLowerCase().replaceAll('-', '_').replaceAll(' ', '_'))
      const memberEmailView = memberSignals.some((value) => ['1', 'true', 'ic_member', 'active_ic_member', 'active_inner_circle_member'].includes(value))
      if (memberEmailView) this.classList.add('is-member-view')
      this.memberView = this.classList.contains('is-member-view')
      this.memberAuthorized = this.dataset.memberAuthorized === 'true'
      if (this.memberView) {
        this.querySelectorAll('[data-archive-box]').forEach((button) => {
          button.setAttribute('aria-disabled', 'true')
          button.setAttribute('tabindex', '-1')
        })
      }
      this.featuredSlides = Array.from(this.querySelectorAll('[data-featured-slide]'))
      this.featuredDots = Array.from(this.querySelectorAll('[data-featured-dot]'))
      this.featuredIndex = 0
      this.track = this.querySelector('[data-box-track]')
      this.sheet = this.querySelector('[data-quick-add]')
      this.sheetImage = this.querySelector('[data-quick-image]')
      this.sheetTitle = this.querySelector('[data-quick-title]')
      this.sheetMonth = this.querySelector('[data-quick-month]')
      this.sheetChoices = this.querySelector('[data-quick-choices]')
      this.sheetSubmit = this.querySelector('[data-quick-submit]')
      this.sheetStatus = this.querySelector('[data-quick-status]')
      this.prospectPrice = this.querySelector('[data-quick-prospect-price]')
      this.memberPrice = this.querySelector('[data-quick-member-price]')
      this.querySelector('[data-featured-prev]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex - 1))
      this.querySelector('[data-featured-next]')?.addEventListener('click', () => this.showFeatured(this.featuredIndex + 1))
      this.featuredDots.forEach((dot) => dot.addEventListener('click', () => this.showFeatured(Number(dot.dataset.featuredDot))))
      this.querySelector('[data-box-prev]')?.addEventListener('click', () => this.scrollBoxes(-1))
      this.querySelector('[data-box-next]')?.addEventListener('click', () => this.scrollBoxes(1))
      this.querySelectorAll('[data-open-quick-add]').forEach((button) => button.addEventListener('click', () => {
        if (this.memberView && button.hasAttribute('data-archive-box')) return
        this.openQuickAdd(button)
      }))
      this.querySelectorAll('[data-close-quick-add]').forEach((button) => button.addEventListener('click', () => this.closeQuickAdd()))
      this.sheetSubmit?.addEventListener('click', () => this.addSelection())
      this.onCartUpdated = (event) => {
        const hasBox = this.cartHasInnerCircleBox(event.detail?.cart)
        if (hasBox || this.memberAuthorized) this.unlockExclusives()
        else this.lockExclusives()
      }
      document.addEventListener('fj:cart-updated', this.onCartUpdated)
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.sheet?.hidden) this.closeQuickAdd()
      })
      this.showFeatured(0)
    }

    disconnectedCallback() {
      document.removeEventListener('fj:cart-updated', this.onCartUpdated)
    }

    showFeatured(index) {
      if (!this.featuredSlides.length) return
      const total = this.featuredSlides.length
      this.featuredIndex = ((index % total) + total) % total
      this.featuredSlides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.featuredIndex
        slide.hidden = !active
        slide.classList.toggle('is-active', active)
      })
      this.featuredDots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.featuredIndex
        dot.classList.toggle('is-active', active)
        dot.setAttribute('aria-current', active ? 'true' : 'false')
      })
    }

    scrollBoxes(direction) {
      const firstCard = this.track?.querySelector('.sw-box-card')
      const cardStep = firstCard ? firstCard.getBoundingClientRect().width + 16 : Math.min((this.track?.clientWidth || 0) * .82, 660)
      this.track?.scrollBy({ left: direction * cardStep, behavior: 'smooth' })
    }

    isInnerCircleBox(item) {
      const productId = Number(item.product_id)
      const knownBoxIds = [
        7887560048718, 7887558082638, 7867028078670, 7853966491726, 7839072256078,
        7793404215374, 7787273846862, 7782868746318, 7769530073166, 7739526742094,
        7712452640846, 7690278338638, 7667317702734, 7639931584590, 7515393032270
      ]
      const properties = item.properties || {}
      const title = String(item.product_title || item.title || '')
      return knownBoxIds.includes(productId)
        || properties._fj_ic_box === 'true'
        || Boolean(item.selling_plan_allocation)
        || item.product_type === 'Monthly Shipment'
        || /subscription box/i.test(title)
    }

    cartHasInnerCircleBox(cart) {
      return (cart?.items || []).some((item) => this.isInnerCircleBox(item))
    }

    openQuickAdd(button) {
      if (button.disabled) return
      this.activeTrigger = button
      this.activeSubscription = button.dataset.subscription === 'true'
      this.activeExclusive = button.dataset.exclusive === 'true'
      this.selectedVariant = null
      this.sheetImage.src = button.dataset.image
      this.sheetImage.alt = button.dataset.title
      this.sheetTitle.textContent = button.dataset.title
      this.sheetMonth.textContent = button.dataset.month
      this.sheetStatus.textContent = ''
      this.sheetChoices.replaceChildren()
      const variants = (button.dataset.variants || '').split(';').map((entry) => entry.split('~')).filter((entry) => entry[0])
      variants.forEach(([id, label], index) => {
        const choice = document.createElement('button')
        choice.type = 'button'
        choice.textContent = label
        choice.dataset.variantId = id
        choice.addEventListener('click', () => this.selectVariant(choice))
        this.sheetChoices.append(choice)
        if (index === 0) this.selectVariant(choice)
      })
      this.prospectPrice.textContent = this.activeSubscription
        ? 'Your first subscription box is $19.98. The regular monthly rate is $39.95 after the promotional offer ends.'
        : 'Member-exclusive item pricing is shown above.'
      this.memberPrice.textContent = this.activeSubscription
        ? 'Your 25%-off member price is $29.96 before tax.'
        : 'Your member-exclusive item price is shown above.'
      this.sheet.hidden = false
      document.documentElement.style.overflow = 'hidden'
      this.querySelector('[data-close-quick-add]')?.focus()
    }

    selectVariant(choice) {
      this.sheetChoices.querySelectorAll('button').forEach((button) => button.classList.toggle('is-selected', button === choice))
      this.selectedVariant = choice.dataset.variantId
      this.sheetSubmit.disabled = !this.selectedVariant
    }

    closeQuickAdd() {
      this.sheet.hidden = true
      document.documentElement.style.overflow = ''
      this.activeTrigger?.focus()
    }

    async addSelection() {
      if (!this.selectedVariant || this.sheetSubmit.disabled) return
      this.sheetSubmit.disabled = true
      this.sheetStatus.textContent = 'Checking your cart…'
      try {
        const cartBeforeResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        const cartBefore = await cartBeforeResponse.json()
        const hasInnerCircleBox = this.cartHasInnerCircleBox(cartBefore)
        if (this.activeSubscription && hasInnerCircleBox) {
          throw new Error('Only one Inner Circle box can be in your cart at a time. Remove your current box before choosing another.')
        }
        if (this.activeExclusive && !this.memberAuthorized && !hasInnerCircleBox) {
          this.lockExclusives()
          throw new Error('Add an Inner Circle box first to unlock this member-exclusive item.')
        }

        this.sheetStatus.textContent = 'Adding your selection…'
        const item = { id: Number(this.selectedVariant), quantity: 1, properties: {} }
        if (this.activeSubscription) {
          item.properties._fj_ic_box = 'true'
          if (!this.memberAuthorized) item.selling_plan = Number(this.dataset.sellingPlan)
        }
        if (this.activeExclusive) {
          item.properties._fj_ic_exclusive = 'true'
          item.properties._fj_requires_ic = 'true'
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.')
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        const cart = await cartResponse.json()
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }))
        if (this.activeSubscription) this.unlockExclusives()
        this.sheetStatus.textContent = 'Added to your cart. Your selection is waiting for you.'
        this.sheetSubmit.textContent = 'Added ✓'
        window.setTimeout(() => { this.sheetSubmit.textContent = 'Add to cart'; this.sheetSubmit.disabled = false }, 1700)
      } catch (error) {
        this.sheetStatus.textContent = error.message || 'This selection could not be added. Please try another size.'
        this.sheetSubmit.disabled = false
      }
    }

    unlockExclusives() {
      this.classList.add('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = false })
    }

    lockExclusives() {
      if (this.memberAuthorized) return
      this.classList.remove('is-unlocked')
      this.querySelectorAll('[data-exclusive="true"]').forEach((button) => { button.disabled = true })
    }
  }

  if (!customElements.get('snow-white-proof')) customElements.define('snow-white-proof', SnowWhiteProof)

  } catch(e) { console.error(e); }
})();
})();
